import { ProgressTrackerStatus } from 'models/account';
import { Business, BusinessPlan } from 'models/business';

export const isBusinessTaxOnly = (business?: Business): boolean =>
  business?.formationsPlan === BusinessPlan.TaxOnly;

export const isBusinessBusinessInABox = (business?: Business): boolean =>
  business?.formationsPlan === BusinessPlan.BIB;

export const isBusinessFullSuite = (business?: Business): boolean =>
  business?.formationsPlan == null ||
  business?.formationsPlan === BusinessPlan.FullSuite;

export const isBusinessHasHurdlrConnected = (company?: Business): boolean =>
  !!company?.hurdlr?.isConnected;

export const isBusinessPayrollEnabled = (company?: Business): boolean =>
  !company?.disabledPayroll;

const getStates = (state: any, isFromIncorporated: boolean = false) => {
  let states;
  if (isFromIncorporated) {
    states = Object.keys(state);
  } else {
    states = Object.keys(state.steps);
  }
  return states;
};

const isStatusCompleted = (
  state: any,
  item: string,
  isFromIncorporated: boolean = false,
) => {
  if (isFromIncorporated) {
    return state[item]?.status === ProgressTrackerStatus.Completed;
  }
  return state.steps[item]?.status === ProgressTrackerStatus.Completed;
};

const isActionableStep = (state: any, item: string) => {
  const actionableStep = !(
    state[item]?.status === ProgressTrackerStatus.Completed ||
    state[item]?.status === ProgressTrackerStatus.InProgress
  );
  return actionableStep;
};

export const getCompletedCount = (
  state: any,
  isFromIncorporated: boolean = false,
) => {
  const states = getStates(state, isFromIncorporated);
  if (states.length > 0) {
    return states.filter((item) =>
      isStatusCompleted(state, item, isFromIncorporated),
    ).length;
  }
  return 0;
};

export const getFirstNoCompleted = (
  state: any,
  isFromIncorporated: boolean = false,
) => {
  const states = getStates(state, isFromIncorporated);
  if (states.length > 0) {
    return states.findIndex(
      (item) => !isStatusCompleted(state, item, isFromIncorporated),
    );
  }
  return -1;
};

/**
 * Returns the index of the first actionable step in a given stage.
 * A step is considered not actionable if it is complete or currently
 * in progress (i.e., in review by Fromations).
 *
 * @param state state object containing current progress for each step
 * @returns index of first actionable step if exists, otherwise -1 if none found
 */
export const getFirstActionableStep = (state: any) => {
  const states = getStates(state, true);
  if (states.length > 0) {
    return states.findIndex((item) => isActionableStep(state, item));
  }
  return -1;
};
